export const INITIAL_DATA_LOAD: string = 'news:INITIAL_DATA_LOAD';
export const INITIAL_DATA_LOAD_SUCCESS: string =
  'news:INITIAL_DATA_LOAD_SUCCESS';

export const loadInitialDatas = () => ({
  type: INITIAL_DATA_LOAD,
});



// WEBPACK FOOTER //
// ./src/modules/news/actions/index.js